import React from "react";
import { withRouter } from "react-router-dom";
import { Auth } from "aws-amplify";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Paper from "@material-ui/core/Paper";
import GetAppIcon from "@material-ui/icons/GetApp";

const BASE = "https://l8rqkk68xl.execute-api.af-south-1.amazonaws.com/production";
const PREFIX = "https://v-n-a.link/";
const JUNK = /[\u200B-\u200D\u2060\uFEFF]/g;

// Lenient normalisation (mirrors the lambda): anything that works pasted in a browser is accepted.
function normCode(v) {
  const c = String(v || "")
    .replace(JUNK, "")
    .replace(/\u00A0/g, " ")
    .trim()
    .replace(/^https?:\/\/(www\.)?v-n-a\.link\//i, "")
    .replace(/\s+/g, "")
    .toLowerCase();
  if (!c) return { error: "Required" };
  if (!/^[a-z0-9_.~-]+$/.test(c)) return { error: "Only letters, numbers, - _ . ~" };
  return { value: c };
}
function normUrl(v) {
  let u = String(v || "")
    .replace(JUNK, "")
    .replace(/\u00A0/g, " ")
    .replace(/[\u201C\u201D\u2018\u2019]/g, "")
    .trim();
  if (!u) return { error: "Required" };
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(u)) u = "https://" + u;
  try {
    const p = new URL(u);
    if (!/^https?:$/.test(p.protocol) || !p.hostname.includes(".")) throw new Error();
    return { value: p.href };
  } catch (e) {
    return { error: "Not a valid URL" };
  }
}

class ShortcodesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authState: this.props.authState,
      shortcodes: [],
      newCode: "",
      newUrl: "",
      newErr: {},
      editing: null, // {code, newCode, newUrl, err}
      busy: false,
      statusbar: false,
      statusbartext: "",
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.authState.state !== "signedIn") this.props.history.push("/");
      else this.load();
    }, 1000);
  }

  doSnackBar(t) {
    this.setState({ statusbar: true, statusbartext: t });
  }

  async api(method, body) {
    const session = await Auth.currentSession();
    const r = await fetch(BASE + "/shortcodes", {
      method,
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "X-Id-Token": session.getIdToken().getJwtToken(),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const t = await r.text();
    const j = t ? JSON.parse(t) : {};
    if (!r.ok) throw new Error(j.error || "Request failed (" + r.status + ")");
    return j;
  }

  async load() {
    try {
      const j = await this.api("GET");
      this.setState({
        shortcodes: j.Items.sort((a, b) => a.code.localeCompare(b.code)),
      });
    } catch (e) {
      this.doSnackBar(e.message);
    }
  }

  async run(fn, okText) {
    this.setState({ busy: true });
    try {
      await fn();
      this.doSnackBar(okText);
      await this.load();
      return true;
    } catch (e) {
      this.doSnackBar(e.message);
      return false;
    } finally {
      this.setState({ busy: false });
    }
  }

  async create() {
    const c = normCode(this.state.newCode);
    const u = normUrl(this.state.newUrl);
    if (c.error || u.error) return this.setState({ newErr: { code: c.error, url: u.error } });
    const ok = await this.run(() => this.api("POST", { code: c.value, url: u.value }), "Created");
    if (ok) this.setState({ newCode: "", newUrl: "", newErr: {} });
  }

  async save() {
    const e = this.state.editing;
    const c = normCode(e.newCode);
    const u = normUrl(e.newUrl);
    if (c.error || u.error)
      return this.setState({ editing: { ...e, err: { code: c.error, url: u.error } } });
    const ok = await this.run(
      () => this.api("PUT", { oldCode: e.code, code: c.value, url: u.value }),
      "Saved"
    );
    if (ok) this.setState({ editing: null });
  }

  async remove(code) {
    if (!window.confirm("Delete short code '" + code + "'? The link will stop working.")) return;
    await this.run(() => this.api("DELETE", { code }), "Deleted");
  }

  // unchanged: uses the existing getcodes endpoint
  async getlog(code) {
    this.doSnackBar("Getting log. Takes a minute.");
    let s = await fetch(BASE + "/getcodes?func=getlog&code=" + code.toLowerCase(), {
      method: "GET",
      mode: "cors",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        AuthToken: "6e3543b0-aa31-429e-a5a3-aa60c90e083a",
        Accept: "application/json",
      },
    });
    let t = await s.json();
    t.forEach((z) => (z.date = z.date.value));
    let text = "date,agent,shortcode\n";
    t.forEach((z) => {
      text += z.date + "," + z.agent + "," + z.shortcode + "\n";
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(new Blob([text], { type: "text/plain" }));
    link.download = code + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const { editing, busy, newErr } = this.state;
    return (
      <div style={{ padding: 10 }}>
        <Snackbar
          open={this.state.statusbar}
          autoHideDuration={4000}
          onClose={() => this.setState({ statusbar: false })}
          message={this.state.statusbartext}
        />
        <Paper style={{ padding: 10, background: "#eee" }}>
          <h1>Shortcodes</h1>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><b>Code</b></TableCell>
                <TableCell><b>Actual URL</b></TableCell>
                <TableCell><b>Actions</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow style={{ background: "#aaa" }}>
                <TableCell>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {PREFIX}
                    <TextField
                      style={{ marginLeft: 10, width: "60%" }}
                      size="small"
                      variant="outlined"
                      label="New short code"
                      value={this.state.newCode}
                      error={!!newErr.code}
                      helperText={newErr.code}
                      onChange={(e) => this.setState({ newCode: e.target.value, newErr: {} })}
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <TextField
                    style={{ width: "100%" }}
                    size="small"
                    variant="outlined"
                    label="Redirect URL"
                    value={this.state.newUrl}
                    error={!!newErr.url}
                    helperText={newErr.url}
                    onChange={(e) => this.setState({ newUrl: e.target.value, newErr: {} })}
                  />
                </TableCell>
                <TableCell>
                  <Button variant="contained" color="primary" disabled={busy} onClick={() => this.create()}>
                    Add new short code
                  </Button>
                </TableCell>
              </TableRow>
              {this.state.shortcodes.map((z) => {
                const ed = editing && editing.code === z.code ? editing : null;
                return (
                  <TableRow key={z.code}>
                    <TableCell>
                      {ed ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {PREFIX}
                          <TextField
                            style={{ marginLeft: 10, width: "60%" }}
                            size="small"
                            variant="outlined"
                            value={ed.newCode}
                            error={!!ed.err.code}
                            helperText={ed.err.code}
                            onChange={(e) =>
                              this.setState({ editing: { ...ed, newCode: e.target.value, err: {} } })
                            }
                          />
                        </div>
                      ) : (
                        PREFIX + z.code
                      )}
                    </TableCell>
                    <TableCell style={{ wordBreak: "break-all" }}>
                      {ed ? (
                        <TextField
                          style={{ width: "100%" }}
                          size="small"
                          variant="outlined"
                          value={ed.newUrl}
                          error={!!ed.err.url}
                          helperText={ed.err.url}
                          onChange={(e) =>
                            this.setState({ editing: { ...ed, newUrl: e.target.value, err: {} } })
                          }
                        />
                      ) : (
                        z.redirect
                      )}
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>
                      {ed ? (
                        <>
                          <Button variant="contained" color="primary" disabled={busy} onClick={() => this.save()}>
                            Save
                          </Button>{" "}
                          <Button disabled={busy} onClick={() => this.setState({ editing: null })}>
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            disabled={busy}
                            onClick={() =>
                              this.setState({
                                editing: { code: z.code, newCode: z.code, newUrl: z.redirect, err: {} },
                              })
                            }
                          >
                            Edit
                          </Button>{" "}
                          <Button variant="outlined" color="secondary" disabled={busy} onClick={() => this.remove(z.code)}>
                            Delete
                          </Button>{" "}
                          <Button variant="contained" color="primary" onClick={() => this.getlog(z.code)}>
                            <GetAppIcon /> Download CSV
                          </Button>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <div>
            <br />
            NB: You can distribute a short URL (eg: https://v-n-a.link/TEst1) with capital letters, the
            backend will convert it to lower case
          </div>
        </Paper>
      </div>
    );
  }
}

export default withRouter(ShortcodesPage);
